import useDeviceSize, { MD_BREAKPOINT, SM_BREAKPOINT } from '../hooks/useDeviceSize';

const TrustpilotNumberOne = () => {
    const { width, height, isMobile } = useDeviceSize();

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: isMobile ? 'row' : 'column',
                alignItems: 'center',
                background: '#FFFFFF',
                boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.25)',
                borderRadius: '12px',
                paddingTop: isMobile ? '1rem' : '0rem',
                paddingLeft: '1.5rem',
                paddingRight: '1.5rem',
                paddingBottom: isMobile ? '1rem' : '2rem',
                maxWidth: isMobile ? '80%' : width < SM_BREAKPOINT ? '220px' : width < MD_BREAKPOINT ? '280px' : '350px',
                gap: isMobile ? '1rem' : 0,
            }}
        >
            <img
                width={width < SM_BREAKPOINT ? '96px' : width < MD_BREAKPOINT ? '128px' : '200px'}
                height='auto'
                src='https://storage.googleapis.com/ebc-solar-quotation-widget/assets/Trustpilot-320x132px.webp'
                alt='Trustpilot'
            />
            <h2
                style={{
                    textAlign: 'center',
                    fontSize: isMobile ? '16px' : width < MD_BREAKPOINT ? '18px' : '24px',
                    fontWeight: 600,
                }}
            >
                Scotland's Number 1
            </h2>
            {!isMobile && (
                <p
                    style={{
                        textAlign: 'center',
                        fontSize: width < MD_BREAKPOINT ? '14px' : '14px',
                        fontWeight: 500,
                        marginTop: '0.5rem',
                    }}
                >
                    We're proud to be the highest rated boiler company on Trustpilot in Scotland
                </p>
            )}
        </div>
    );
};

export default TrustpilotNumberOne;
